var _path, _path2, _ellipse, _ellipse2, _path3, _path4, _path5, _ellipse3, _ellipse4, _path6, _path7, _path8, _ellipse5, _ellipse6, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveForeground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1625,
    height: 325,
    viewBox: "0 0 1625 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.425 62.1973C387.58 54.75 392.654 61.5608 398.191 46.0297C402.998 32.5506 395.967 17.7274 382.488 12.9213C369.009 8.11512 354.186 15.1459 349.379 28.625C344.573 42.1041 351.014 44.2128 349.707 48.7483C348.092 54.3479 337.822 47.0114 330.702 66.98C322.791 89.1673 343.841 105.123 364.792 111.646C386.054 118.266 403.504 115.367 417.232 97.8337C421.824 91.9686 426.337 79.3136 422.925 74.8552C420.606 71.8253 414.551 68.3804 407.394 69.3174C401.489 70.0904 394.301 72.6102 390.28 68.217C388.524 66.2976 387.378 64.454 387.425 62.1973Z",
    fill: "#FFDD38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M340.053 24.3338C334.738 28.1638 346.745 41.0562 354.077 40.9503C359.261 40.8755 364.312 37.7034 362.201 32.4236C360.461 28.0697 356.054 27.2562 351.634 25.6083C347.087 23.9125 343.242 22.0358 340.053 24.3338Z",
    fill: "#FF7E1F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 370.388,
    cy: 26.7525,
    rx: 5.04108,
    ry: 6.60297,
    transform: "rotate(43.8958 370.388 26.7525)",
    fill: "#030303"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.947,
    cy: 24.3166,
    rx: 2.15499,
    ry: 3.31061,
    transform: "rotate(49.8381 369.947 24.3166)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M376.807 77.4482C368.275 74.147 363.96 64.5008 355.919 67.0183C346.771 69.882 350.11 81.1332 355.313 89.1657C362.921 100.911 383.405 106.755 393.114 98.1717C397.819 94.012 401.442 89.503 398.302 83.6217C394.582 76.6506 384.959 80.6022 376.807 77.4482Z",
    fill: "#FCE95F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1408.21 93.1973C1408.05 85.75 1402.98 92.5608 1397.44 77.0297C1392.63 63.5506 1399.67 48.7274 1413.14 43.9213C1426.62 39.1151 1441.45 46.1459 1446.25 59.625C1451.06 73.1041 1444.62 75.2128 1445.93 79.7483C1447.54 85.3479 1457.81 78.0114 1464.93 97.98C1472.84 120.167 1451.79 136.123 1430.84 142.646C1409.58 149.266 1392.13 146.367 1378.4 128.834C1373.81 122.969 1369.3 110.314 1372.71 105.855C1375.03 102.825 1381.08 99.3804 1388.24 100.317C1394.14 101.09 1401.33 103.61 1405.35 99.217C1407.11 97.2976 1408.25 95.454 1408.21 93.1973Z",
    fill: "#FFDD38"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1455.58 55.3338C1460.89 59.1638 1448.89 72.0562 1441.56 71.9503C1436.37 71.8755 1431.32 68.7034 1433.43 63.4236C1435.17 59.0697 1439.58 58.2562 1444 56.6083C1448.55 54.9125 1452.39 53.0358 1455.58 55.3338Z",
    fill: "#FF7E1F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.04108,
    ry: 6.60297,
    transform: "matrix(-0.720601 0.69335 0.69335 0.720601 1425.24 57.7525)",
    fill: "#030303"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.15499,
    ry: 3.31061,
    transform: "matrix(-0.64495 0.764225 0.764225 0.64495 1425.69 55.3166)",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1418.82 108.448C1427.36 105.147 1431.67 95.5008 1439.71 98.0183C1448.86 100.882 1445.52 112.133 1440.32 120.166C1432.71 131.911 1412.23 137.755 1402.52 129.172C1397.81 125.012 1394.19 120.503 1397.33 114.622C1401.05 107.651 1410.67 111.602 1418.82 108.448Z",
    fill: "#FCE95F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M857.016 126.301C859.715 121.757 854.105 123.958 856.591 112.526C858.749 102.604 868.542 96.311 878.463 98.469C888.385 100.627 894.678 110.419 892.52 120.341C890.362 130.262 885.692 129.118 884.779 132.34C883.652 136.318 892.589 135.749 889.392 150.447C885.84 166.778 867.178 168.498 852.112 164.573C836.823 160.59 827.397 152.302 825.701 136.594C825.133 131.339 827.159 122.024 830.886 120.618C833.419 119.662 838.358 119.857 842.318 123.104C845.585 125.784 848.97 129.996 853.039 128.857C854.817 128.359 856.198 127.678 857.016 126.301Z",
    fill: "#FFDD38"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M899.747 121.252C901.513 125.552 889.447 128.817 885.07 126.004C881.975 124.016 880.121 120.211 883.372 117.822C886.053 115.852 889.013 117.014 892.293 117.678C895.668 118.362 898.687 118.673 899.747 121.252Z",
    fill: "#FF7E1F"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.57672,
    ry: 4.6849,
    transform: "matrix(-0.978147 0.207913 0.207913 0.978147 880.567 111.337)",
    fill: "#030303"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.529,
    ry: 2.34892,
    transform: "matrix(-0.951367 0.308059 0.308059 0.951367 881.746 110.035)",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M857.694 139.469C864.072 140.679 870.287 136.486 874.188 141.017C878.624 146.171 872.395 151.697 866.25 154.585C857.264 158.808 842.733 154.649 840.102 145.839C838.827 141.569 838.336 137.495 842.432 135.129C847.286 132.325 851.601 138.313 857.694 139.469Z",
    fill: "#FCE95F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M803.371 141.441C496.629 59.8592 139.981 107.449 0 141.441V325H1625V76C1478.93 109.992 1110.11 223.023 803.371 141.441Z",
    fill: "#4BE9FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveForeground);
export default __webpack_public_path__ + "static/media/wave-foreground.a0b03d452d08b69275994c43687e1ddc.svg";
export { ForwardRef as ReactComponent };